import { makeAutoObservable, runInAction } from "mobx";
import {
  superadminGetPaymentDetail,
  superadminGetPaymentEvents,
} from "@pro-sto/api-client";
import type {
  SuperadminPaymentDetailResponseDto as PaymentDetail,
  PaymentEventItemDto as PaymentEvent,
} from "@pro-sto/api-client";
import { toastStore } from "../ToastStore";

export class PaymentDetailSubStore {
  detail: PaymentDetail | null = null;
  events: PaymentEvent[] = [];
  isLoading = false;
  selectedUuid: string | null = null;
  isOpen = false;
  description: string | null = null;
  transactionType: "payment" | "payout" | "refund" | null = null;
  defaultTab: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  open = async (
    paymentUuid: string,
    description?: string,
    transactionType?: "payment" | "payout" | "refund",
    defaultTab?: string,
  ) => {
    this.selectedUuid = paymentUuid;
    this.isOpen = true;
    this.isLoading = true;
    this.detail = null;
    this.events = [];
    this.description = description ?? null;
    this.transactionType = transactionType ?? null;
    this.defaultTab = defaultTab ?? null;

    try {
      const [detail, eventsRes] = await Promise.all([
        superadminGetPaymentDetail({ uuid: paymentUuid }),
        superadminGetPaymentEvents({ uuid: paymentUuid }),
      ]);
      runInAction(() => {
        this.detail = detail;
        this.events = eventsRes.data ?? [];
        this.isLoading = false;
      });
    } catch {
      runInAction(() => {
        this.isLoading = false;
      });
      toastStore.showError("Не удалось загрузить детали транзакции");
    }
  };

  close = () => {
    this.isOpen = false;
    this.selectedUuid = null;
    this.defaultTab = null;
  };

  reset = () => {
    this.detail = null;
    this.events = [];
    this.selectedUuid = null;
    this.isOpen = false;
    this.description = null;
    this.transactionType = null;
    this.defaultTab = null;
  };
}
